import * as ReactService from "@intech/react-service";
import { ProcessoBeneficioEntidade } from "../entidades/ProcessoBeneficioEntidade";

class ProcessoBeneficio extends ReactService.BaseService {
  constructor() {
    super("ProcessoBeneficio");
  }

  BuscarPorPlano = (cdplano: string) =>
    this.CreateRequest<ProcessoBeneficioEntidade[]>(ReactService.RequestType.GET, `BuscarPorPlano/${cdplano}`);

}

export const ProcessoBeneficioService = new ProcessoBeneficio();
